// #region Imports
//Components    
import { defineComponent } from "vue";
//Mixin
import DxDateBox from 'devextreme-vue/date-box';
// #endregion
// #region Core
export default defineComponent({
    name: 'g-date-edit',
    components: {
        DxDateBox
    },
    mixins: [host.mixins.form],
    props: {
        inputAttr: {
            type: Object,
            required: false,
            default: null,
        },
        showClearButton: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    computed: {
        inputAttrInternal() {
            return this.inputAttr;
        },
    },
    methods: {
        onEnterKey(event) {
            this.$emit('EnterKey', event);
        },
    }
});
// #endregion
